import React from 'react';
import LoginPage from '../Login/LoginPage';

const Signup = () => {
  return (
<>
<LoginPage/>
</>
  );
};

export default Signup;

